import { lazyPipe, validateApiResponse, withApiErrorCapture } from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { curationsApiPath } from './apiPath';

const GetCurationsCheckLimitResponseDataSchema = z.object({
  canCreate: z.boolean(),
  currentCount: z.number(),
  maxCount: z.number(),
  remainingCount: z.number(),
  message: z.string().optional().nullable(), // 생성 불가시 안내 메시지
});

const GetCurationsCheckLimitResponseSchema = createApiResponseSchema(
  GetCurationsCheckLimitResponseDataSchema,
);

type GetCurationsCheckLimitResponse = z.infer<typeof GetCurationsCheckLimitResponseSchema>;

export const getCurationsCheckLimit = withApiErrorCapture(
  lazyPipe(
    async (): Promise<GetCurationsCheckLimitResponse> =>
      executeStandardRequest(async () => {
        const response = await privateHttpClient.get<GetCurationsCheckLimitResponse>(
          curationsApiPath.getCurationsCheckLimit,
        );
        return response;
      }),
    validateApiResponse(GetCurationsCheckLimitResponseSchema),
  ),
);
